/* eslint-disable no-console */
import apiClient from "../_helpers/api-client";

export const aedsService = {
  getAll,
  getFilters,
  getAdmins,
  getAddressCategories,
  getSuggestions,
  getPagination
};

async function getAll(parameters, list = "aedsfulllist") {
  const params = { ...parameters };

  Object.keys(params).forEach(param => {
    const paramValue = params[param];

    if (param == null || !Array.isArray(paramValue)) {
      return;
    }

    params[param] = paramValue.join(" ");
  });
  return await apiClient.get(`/api/v4/${list}`, { params });
}
async function getPagination(parameters = {}, list = "aedsfulllist") {
  const params = { ...parameters };

  Object.keys(params).forEach(param => {
    const paramValue = params[param];

    if (param == null || !Array.isArray(paramValue)) {
      return;
    }

    params[param] = paramValue.join(" ");
  });

  return await apiClient.get(`/api/v4/${list}/pagination`, { params });
}

async function getFilters(list = "aedsfulllist") {
  return await apiClient.get(`/api/v4/${list}/filters`);
}

async function getAdmins() {
  return await apiClient.get("/api/v4/assignees");
}

async function getAddressCategories() {
  return await apiClient.get("/api/v4/aedsfull/addresscategories");
}

async function getSuggestions(params) {
  return await apiClient.get("/api/v4/aedsfulllist/autosuggest", { params });
}
